import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ActionConfirmModal from '../../common/components/actionConfirmModal';
import PermissaoUsuario from '../../auth/permissao';
import {
  showUpdate,
  showHistorico,
  showTrocar,
  remove,
  registrarRemocao,
  setPaginaAtual,
  getList,
} from './inventarioActions';
import SPButton from '../../common/form/spButton';
import ReactTableGT2A from '../../common/grid/gridReactTable';
import PremiumTableShell from '../../common/grid/premiumTableShell';
import { premiumBadge } from '../manutencaoListUtils';

const FILTRO_TODOS = '';

const STATUS_LABELS = {
  INSTALADO: 'Instalado',
  REMOVIDO: 'Removido',
  DEFEITO: 'Com defeito',
};

const STATUS_BADGE = {
  INSTALADO: 'os-badge--green',
  REMOVIDO: 'os-badge--gray',
  DEFEITO: 'os-badge--red',
};

function formatarData(valor) {
  if (!valor) return '—';
  return new Date(valor).toLocaleDateString('pt-BR');
}

function formatarControlador(item) {
  if (!item || (item.numero_controlador === null || item.numero_controlador === undefined)) return '—';
  const numero = String(item.numero_controlador).padStart(2, '0');
  const endereco = item.cruzamento || item.controlador_endereco;
  return endereco ? `Ctrl ${numero} — ${endereco}` : `Ctrl ${numero}`;
}

class InventarioList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filtroBusca: '',
      filtroStatus: FILTRO_TODOS,
      filtroGrupo: FILTRO_TODOS,
      filtroControlador: FILTRO_TODOS,
      excluirItem: null,
      removerItem: null,
    };
    this.aplicarFiltrosRemotos = this.aplicarFiltrosRemotos.bind(this);
  }

  componentDidMount() {
    if (this.props.filtroControladorInicial) {
      this.setState({ filtroControlador: String(this.props.filtroControladorInicial) }, this.aplicarFiltrosRemotos);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.filtroControladorInicial !== prevProps.filtroControladorInicial) {
      this.setState(
        { filtroControlador: String(this.props.filtroControladorInicial || '') },
        this.aplicarFiltrosRemotos,
      );
    }
  }

  aplicarFiltrosRemotos() {
    const params = {};
    if (this.state.filtroStatus) params.status = this.state.filtroStatus;
    if (this.state.filtroGrupo) params.grupo_fisico_id = this.state.filtroGrupo;
    if (this.state.filtroControlador) params.controlador_id = this.state.filtroControlador;
    if (this.state.filtroBusca) params.q = this.state.filtroBusca;
    this.props.getList(params);
    this.props.setPaginaAtual(0);
  }

  handleBuscaChange = event => {
    this.setState({ filtroBusca: event.target.value }, this.aplicarFiltrosRemotos);
  };

  handleStatusChange = event => {
    this.setState({ filtroStatus: event.target.value }, this.aplicarFiltrosRemotos);
  };

  handleGrupoChange = event => {
    this.setState({ filtroGrupo: event.target.value, filtroControlador: FILTRO_TODOS }, this.aplicarFiltrosRemotos);
  };

  handleControladorChange = event => {
    this.setState({ filtroControlador: event.target.value }, this.aplicarFiltrosRemotos);
  };

  handlePageChange = page => {
    this.props.setPaginaAtual(page);
  };

  confirmarExclusaoItem = () => {
    const { excluirItem } = this.state;
    if (!excluirItem) return;
    this.props.remove(excluirItem);
    this.setState({ excluirItem: null });
  };

  confirmarRemocaoItem = () => {
    const { removerItem } = this.state;
    if (!removerItem) return;
    this.props.registrarRemocao(removerItem.id, { observacao: 'Remoção registrada pela listagem' });
    this.setState({ removerItem: null });
  };

  renderFiltros() {
    const { opcoes } = this.props;
    const controladores = (opcoes.controladores || []).filter(
      c => !this.state.filtroGrupo || String(c.grupo_fisico_id) === this.state.filtroGrupo,
    );

    return (
      <div className="os-list-filters-bar">
        <div className="os-list-filter-group os-list-filter-group--search">
          <label className="os-list-filter-label" htmlFor="inv-filtro-busca">
            Buscar
          </label>
          <input
            id="inv-filtro-busca"
            type="search"
            className="form-control os-list-filter-input"
            value={this.state.filtroBusca}
            onChange={this.handleBuscaChange}
            placeholder="Tipo, série, cruzamento..."
          />
        </div>
        <div className="os-list-filter-group">
          <label className="os-list-filter-label" htmlFor="inv-filtro-status">
            Status
          </label>
          <select
            id="inv-filtro-status"
            className="form-control os-list-filter-select"
            value={this.state.filtroStatus}
            onChange={this.handleStatusChange}
          >
            <option value={FILTRO_TODOS}>Todos</option>
            <option value="INSTALADO">Instalados</option>
            <option value="DEFEITO">Com defeito</option>
            <option value="REMOVIDO">Removidos</option>
          </select>
        </div>
        <div className="os-list-filter-group">
          <label className="os-list-filter-label" htmlFor="inv-filtro-grupo">
            Grupo Físico
          </label>
          <select
            id="inv-filtro-grupo"
            className="form-control os-list-filter-select"
            value={this.state.filtroGrupo}
            onChange={this.handleGrupoChange}
          >
            <option value={FILTRO_TODOS}>Todos</option>
            {(opcoes.grupos_fisicos || []).map(g => (
              <option key={g.id} value={String(g.id)}>
                {g.descricao}
              </option>
            ))}
          </select>
        </div>
        <div className="os-list-filter-group">
          <label className="os-list-filter-label" htmlFor="inv-filtro-controlador">
            Controlador
          </label>
          <select
            id="inv-filtro-controlador"
            className="form-control os-list-filter-select"
            value={this.state.filtroControlador}
            onChange={this.handleControladorChange}
          >
            <option value={FILTRO_TODOS}>Todos</option>
            {controladores.map(c => (
              <option key={c.id} value={String(c.id)}>
                {`Ctrl ${String(c.numero_controlador).padStart(2, '0')}${c.endereco ? ` — ${c.endereco}` : ''}`}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }

  renderAcoes(row) {
    const item = row.original;
    const instalado = item.status === 'INSTALADO' || item.status === 'DEFEITO';

    return (
      <div className="os-actions-cell">
        <div className="os-actions-group">
          <PermissaoUsuario tela="CadManutencaoInventario" campo="alterar" condicao={true}>
            <SPButton
              type="button"
              className="warning btn-sm"
              icon="pencil-alt"
              data-title="Alterar"
              onClick={() => this.props.showUpdate(item)}
            />
          </PermissaoUsuario>
          <PermissaoUsuario tela="CadManutencaoInventario" campo="historico" condicao={true}>
            <SPButton
              type="button"
              className="default btn-sm"
              icon="history"
              data-title="Histórico"
              onClick={() => this.props.showHistorico(item)}
            />
          </PermissaoUsuario>
          {instalado && (
            <PermissaoUsuario tela="CadManutencaoInventario" campo="alterar" condicao={true}>
              <SPButton
                type="button"
                className="info btn-sm"
                icon="exchange-alt"
                data-title="Trocar equipamento"
                onClick={() => this.props.showTrocar(item)}
              />
              <SPButton
                type="button"
                className="default btn-sm"
                icon="sign-out-alt"
                data-title="Registrar remoção"
                onClick={() => this.setState({ removerItem: item })}
              />
            </PermissaoUsuario>
          )}
          <PermissaoUsuario tela="CadManutencaoInventario" campo="excluir" condicao={true}>
            <SPButton
              type="button"
              className="danger btn-sm"
              icon="trash-alt"
              data-title="Excluir"
              onClick={() => this.setState({ excluirItem: item })}
            />
          </PermissaoUsuario>
        </div>
      </div>
    );
  }

  render() {
    const { list, paginaAtual } = this.props;
    const itens = list || [];

    const columns = [
      {
        Header: 'Ações',
        Cell: row => this.renderAcoes(row),
        className: 'column_icon',
        width: 196,
        resizable: false,
        sortable: false,
        filterable: false,
      },
      {
        Header: 'Tipo',
        accessor: 'tipo_nome',
        minWidth: 180,
        className: 'column_grid column_left manutencao-col-texto',
        filterable: false,
        Cell: row => <span className="os-cell-ellipsis">{row.value || '—'}</span>,
      },
      {
        Header: 'Categoria',
        accessor: 'tipo_categoria_nome',
        width: 120,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row =>
          premiumBadge(row.value || row.original.tipo_categoria || '—', row.original.tipo_categoria_badge || 'os-badge--gray'),
      },
      {
        Header: 'Etiqueta / Série',
        id: 'identificacao',
        accessor: row => {
          const parts = [];
          if (row.etiqueta) parts.push(row.etiqueta);
          if (row.numero_serie) parts.push(`S/N ${row.numero_serie}`);
          return parts.join(' · ') || '—';
        },
        minWidth: 160,
        className: 'column_grid column_left manutencao-col-texto',
        filterable: false,
        Cell: row => <span className="os-cell-ellipsis">{row.value}</span>,
      },
      {
        Header: 'Status',
        accessor: 'status',
        width: 110,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => premiumBadge(STATUS_LABELS[row.value] || row.value, STATUS_BADGE[row.value] || 'os-badge--gray'),
      },
      {
        Header: 'Instalação',
        accessor: 'data_instalacao',
        width: 100,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => <span className="os-cell-data">{formatarData(row.value)}</span>,
      },
      {
        Header: 'Garantia',
        accessor: 'data_garantia_fim',
        width: 100,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => <span className="os-cell-data">{formatarData(row.value)}</span>,
      },
    ];

    return (
      <div className="manutencao-premium-list table-container inventario-premium-list">
        <div className="os-list-top-panel">
          <p className="os-list-summary">{`${itens.length} equipamento(s) no inventário`}</p>
          {this.renderFiltros()}
        </div>
        <PremiumTableShell summary="" hideToolbar tableMinWidth={0}>
          <ReactTableGT2A
            data={itens}
            columns={columns}
            className="-striped -highlight"
            defaultPageSize={15}
            showPagination
            filterable={false}
            page={paginaAtual || 0}
            onPageChange={this.handlePageChange}
            minRows={0}
            noDataText="Nenhum equipamento encontrado."
          />
        </PremiumTableShell>

        <ActionConfirmModal
          show={!!this.state.excluirItem}
          title="Deseja realmente excluir?"
          message="O registro será removido permanentemente do inventário."
          itemName={this.state.excluirItem ? this.state.excluirItem.tipo_nome : ''}
          itemDetail={this.state.excluirItem ? formatarControlador(this.state.excluirItem) : ''}
          confirmLabel="Excluir"
          destructive
          icon="trash-alt"
          onConfirm={this.confirmarExclusaoItem}
          onCancel={() => this.setState({ excluirItem: null })}
        />

        <ActionConfirmModal
          show={!!this.state.removerItem}
          title="Registrar remoção?"
          message="O equipamento será marcado como removido. O histórico será preservado no inventário."
          itemName={this.state.removerItem ? this.state.removerItem.tipo_nome : ''}
          itemDetail={this.state.removerItem ? formatarControlador(this.state.removerItem) : ''}
          confirmLabel="Registrar remoção"
          icon="archive"
          onConfirm={this.confirmarRemocaoItem}
          onCancel={() => this.setState({ removerItem: null })}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.manutencaoInventario.list,
  opcoes: state.manutencaoInventario.opcoes,
  paginaAtual: state.manutencaoInventario.paginaAtual,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { showUpdate, showHistorico, showTrocar, remove, registrarRemocao, setPaginaAtual, getList },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(InventarioList);
